(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
if (!customElements.get('angimy-shipping')) {
  customElements.define('angimy-shipping', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.country = this.querySelector('[data-country]');
      this.province = this.querySelector('[data-province]');
      this.zip = this.querySelector('[data-zip]');
      this.button = this.querySelector('[data-estimate]');
      this.results = this.querySelector('[data-results]');
      this.version = 0;
      this.country.value = 'France';
      if (!this.country.value) this.country.selectedIndex = 0;
      this.regions();
      this.addEventListener('change', (event) => {
        this.reset();
        if (event.target === this.country) this.regions();
      });
      this.zip.addEventListener('input', () => this.reset());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target === this.zip) {
          event.preventDefault();
          this.button.click();
        }
      });
      this.button.addEventListener('click', () => this.estimate());
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.reset());
      }
    }
    disconnectedCallback() {
      this.reset();
      if (this.unsubscribe) this.unsubscribe();
      this.ready = false;
    }
    reset() {
      this.version++;
      this.results.replaceChildren();
      this.button.disabled = false;
      this.button.textContent = this.dataset.buttonLabel || 'Estimer';
    }
    regions() {
      const option = this.country.selectedOptions[0];
      const regions = JSON.parse(option?.dataset.provinces || '[]');
      this.province.replaceChildren();
      regions.forEach(([value, label]) => this.province.add(new Option(label, value)));
      this.querySelector('[data-region]').hidden = !regions.length;
    }
    async estimate() {
      if (this.button.disabled) return;
      const version = ++this.version;
      const root = window.Shopify?.routes?.root || '/';
      const query = new URLSearchParams({
        'shipping_address[country]': this.country.value,
        'shipping_address[province]': this.province.value,
        'shipping_address[zip]': this.zip.value.trim()
      });
      this.button.disabled = true;
      this.button.textContent = this.dataset.loadingLabel || 'Calcul en cours…';
      this.results.textContent = '';
      const request = async (url, method = 'GET') => {
        const response = await fetch(url, {
          method, credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('request');
        return response.json();
      };
      try {
        await request(root + 'cart/prepare_shipping_rates.json?' + query, 'POST');
        for (let attempt = 0; attempt < 20; attempt++) {
          if (version !== this.version || !this.isConnected) return;
          const data = await request(root + 'cart/async_shipping_rates.json?' + query);
          if (version !== this.version || !this.isConnected) return;
          if (data && Array.isArray(data.shipping_rates)) {
            if (!data.shipping_rates.length) {
              this.results.textContent = 'Aucun tarif disponible pour cette destination. Vérifiez votre adresse ou poursuivez au paiement.';
              return;
            }
            data.shipping_rates.forEach(rate => {
              const row = document.createElement('div');
              row.className = 'as-rate';
              const name = document.createElement('span');
              name.textContent = rate.presentment_name || rate.name;
              const price = document.createElement('strong');
              price.textContent = (window.angimyEuro || ((n) => String(n).replace('.', ',') + '€'))(Number(rate.price));
              row.append(name, price);
              this.results.append(row);
            });
            return;
          }
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        throw new Error('timeout');
      } catch (error) {
        if (version === this.version) {
          this.results.textContent = 'Impossible de calculer les frais pour le moment. Vérifiez le pays, la région et le code postal, puis réessayez. Vous pouvez aussi poursuivre au paiement.';
        }
      } finally {
        if (version === this.version) {
          this.button.disabled = false;
          this.button.textContent = this.dataset.buttonLabel || 'Estimer';
        }
      }
    }
  });
}
if (!customElements.get('angimy-discount')) {
  customElements.define('angimy-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('.ad-form');
      this.input = this.querySelector('[data-code]');
      this.button = this.querySelector('[data-apply]');
      this.status = this.querySelector('[data-status]');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.apply(this.input.value);
      });
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove]');
        if (!remove) return;
        event.preventDefault();
        this.remove(remove.dataset.remove);
      });
      this.syncChips();
    }
    existingCodes() {
      return [...this.querySelectorAll('[data-applied-code]')]
        .map((el) => (el.dataset.appliedCode || '').trim())
        .filter(Boolean);
    }
    normalize(code) {
      return (code || '').trim().replace(/\s+/g, '');
    }
    setBusy(busy) {
      this.button.disabled = busy;
      this.input.disabled = busy;
      this.button.textContent = busy
        ? (this.dataset.loadingLabel || 'Application…')
        : (this.dataset.buttonLabel || 'Appliquer');
    }
    showError(message) {
      this.status.classList.add('is-error');
      this.status.textContent = message;
    }
    clearStatus() {
      this.status.classList.remove('is-error');
      this.status.textContent = '';
    }
    async updateDiscount(value) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount: value }),
        signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('request');
      return response.json();
    }
    appliedList(cart) {
      return (cart.discount_codes || [])
        .filter((item) => item && item.applicable !== false && item.code)
        .map((item) => String(item.code));
    }
    hasCode(codes, code) {
      const needle = code.toUpperCase();
      return codes.some((item) => String(item).toUpperCase() === needle);
    }
    reloadCart() {
      window.location.reload();
    }
    async fetchCart() {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('request');
      return response.json();
    }
    async syncChips() {
      try {
        const cart = await this.fetchCart();
        this.renderChips(this.appliedList(cart), cart);
      } catch (error) {
        /* keep Liquid chips if cart.js is unavailable */
      }
    }
    renderChips(codes, cart) {
      const unique = [...new Map(codes.map((code) => [String(code).toUpperCase(), String(code)])).values()];
      let list = this.querySelector('.ad-codes');
      if (!unique.length) {
        if (list) list.remove();
        return;
      }
      if (!list) {
        list = document.createElement('ul');
        list.className = 'ad-codes';
        list.setAttribute('role', 'list');
        this.append(list);
      }
      const savings = {};
      (cart.items || []).forEach((item) => {
        (item.discounts || []).forEach((discount) => {
          if (!discount?.title) return;
          savings[String(discount.title).toUpperCase()] = (savings[String(discount.title).toUpperCase()] || 0) + Number(discount.amount || 0);
        });
      });
      const currency = cart.currency || this.dataset.currency || 'EUR';
      const money = (cents) => (window.angimyEuro || ((n, fromCents) => ((fromCents ? Number(n) / 100 : Number(n)).toFixed(2).replace('.', ',') + '€')))(cents, true);
      list.replaceChildren();
      unique.forEach((code) => {
        const li = document.createElement('li');
        li.className = 'ad-chip';
        li.dataset.appliedCode = code;
        const label = document.createElement('span');
        label.className = 'ad-chip__code';
        label.textContent = code;
        li.append(label);
        const amount = savings[code.toUpperCase()];
        if (amount > 0) {
          const save = document.createElement('span');
          save.className = 'ad-chip__save';
          save.textContent = '-' + money(amount);
          li.append(save);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ad-chip__remove';
        button.dataset.remove = code;
        button.setAttribute('aria-label', (this.dataset.removeLabel || 'Retirer') + ' ' + code);
        button.textContent = '×';
        li.append(button);
        list.append(li);
      });
    }
    async apply(rawCode) {
      if (this.button.disabled) return;
      const code = this.normalize(rawCode);
      if (!code) {
        this.showError(this.dataset.emptyText || 'Saisissez un code promo.');
        this.input.focus();
        return;
      }
      const existing = this.existingCodes();
      if (this.hasCode(existing, code)) {
        this.clearStatus();
        this.input.value = '';
        return;
      }
      this.clearStatus();
      this.setBusy(true);
      try {
        const next = [...existing, code].join(',');
        const cart = await this.updateDiscount(next);
        if (!this.hasCode(this.appliedList(cart), code)) {
          if (existing.length) await this.updateDiscount(existing.join(','));
          else await this.updateDiscount('');
          this.showError(this.dataset.errorText || 'Ce code n’est pas applicable à ce panier.');
          return;
        }
        this.reloadCart();
      } catch (error) {
        const redirect = window.location.pathname + window.location.search;
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(
          root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect)
        );
      } finally {
        if (this.isConnected) this.setBusy(false);
      }
    }
    async remove(rawCode) {
      if (this.button.disabled) return;
      const code = this.normalize(rawCode);
      const remaining = this.existingCodes().filter((item) => item.toUpperCase() !== code.toUpperCase());
      this.clearStatus();
      this.setBusy(true);
      try {
        await this.updateDiscount(remaining.join(','));
        this.reloadCart();
      } catch (error) {
        this.showError(this.dataset.errorText || 'Ce code n’est pas applicable à ce panier.');
      } finally {
        if (this.isConnected) this.setBusy(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
